module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "previewArea",
    style: ({
      height: _vm.height + 'px'
    })
  }, [(_vm.imgVisible) ? _c('div', {
    staticClass: "imgArea"
  }, [_c('el-image', {
    attrs: {
      "src": _vm.fileInfo.url
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.txtVisible) ? _c('div', {
    staticClass: "txtArea"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.txtContent)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.pdfVisible) ? _c('div', {
    staticClass: "pdfArea"
  }, _vm._l((_vm.pdfPages), function(currentPage) {
    return _c('pdf', {
      key: currentPage,
      ref: "pdf",
      refInFor: true,
      attrs: {
        "src": _vm.pdfSrc,
        "page": currentPage
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "videoArea"
  }, [(_vm.initPlayerCompleted) ? _c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "x5-video-player-type": "h5",
      "x5-video-player-orientation": "landscape",
      "options": _vm.playerOptions
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c0cd550"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/file/simplePreviewer.vue
// module id = 1881
// module chunks = 502